import { useDataModel } from '@thd-nucleus/data-sources';
import { getApiParams } from '../utils/queryParamsHelpers';
import { isServer } from '../utils/helpers';

const useSponsoredBannerApi = ({
  guestUserID,
  experienceContext,
  pageContext,
  schema,
  bannerType,
  mcvisID,
  shouldSuppress,
  isUniversalBannerEligible,
  isLeaderboardEnabled,
  matchProducts,
  anchorSku,
  mounted,
  nValue,
}) => {
  const {
    pageType,
    channel,
    customerType,
    category,
    keyword,
    customerIdentifier,
    forceAd
  } = getApiParams({
    guestUserID, experienceContext, pageContext, schema
  });

  const experienceMetadata = isServer() ? undefined : window.experienceMetadata;

  const { data, loading, error } = useDataModel('sponsored', {
    skip: !mounted || shouldSuppress || (bannerType === 'leaderboard' && !isLeaderboardEnabled) || !isUniversalBannerEligible,
    ssr: false,
    variables: {
      nValue,
      bannerType,
      marketingId: mcvisID,
      pageType,
      category,
      customerType,
      channel,
      customerIdentifier,
      anchorSku,
      forceAd,
      keyword,
      matchProducts,
      experienceName: experienceMetadata?.name,
      experienceVersion: experienceMetadata?.version
    }
  });

  return { data, loading, error };
};

export default useSponsoredBannerApi;
